import { IHiddenColumnIssues } from '@molecules/formbuilder/controls/Table/controls/tableHiddenIssues';
import { plural } from '@srm/ui/lib/pluralize';

export interface IHiddenIssuesMessage {
    tone: 'warning' | 'danger';
    /** Первая фраза — что не так (в чипе выделена). */
    headline: string;
    /** Вторая фраза — где искать и что делать. */
    detail: string;
}

const listNames = (titles: string[]): string => {
    const quoted = titles.map((title) => `«${title}»`);
    if (quoted.length === 1) return quoted[0];
    if (quoted.length === 2) return `${quoted[0]} и ${quoted[1]}`;
    const rest = quoted.length - 2;
    return `${quoted[0]}, ${quoted[1]} и ещё ${rest} ${plural(rest, ['столбец', 'столбца', 'столбцов'])}`;
};

const rowsText = (count: number, truncated: boolean) =>
    `${truncated ? 'более ' : ''}${count} ${plural(count, ['строке', 'строках', 'строках'])}`;

/**
 * Короткий текст сигнала: число проблемных строк идёт раньше названий столбцов,
 * поэтому смысл остаётся виден и в тесном туллбаре. После «Показать» сигнал
 * исчезает — открытые столбцы, красные ячейки и фокус уже подтверждают действие.
 */
export const hiddenIssuesMessage = (args: {
    issues: IHiddenColumnIssues | null;
    setName?: string;
    /** Выбор колонок разошёлся с сохранённым набором. */
    dirty: boolean;
    /** Проверка формы не прошла — сигнал эскалирует. */
    failed: boolean;
}): IHiddenIssuesMessage | null => {
    const { issues, setName, dirty, failed } = args;
    if (!issues || issues.columns.length === 0) return null;

    const titles = issues.columns.map((column) => column.title);
    return {
        tone: failed ? 'danger' : 'warning',
        headline: `${failed ? 'Не сохранено · ошибки' : 'Ошибки'} в ${rowsText(
            issues.rowCount,
            issues.truncated,
        )}: ${listNames(titles)}`,
        detail: dirty || !setName ? 'Столбцы скрыты в текущем наборе.' : `Столбцы скрыты в наборе «${setName}».`,
    };
};
